import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { InfoMessage } from './Layout/InfoMessage';


export default buildFacetDesignOverride()
  .nameOverride('infoMessage', {
    _component: () => InfoMessage,
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => BodyTextMedium,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly);
